import registrationStyles from '../../styles';

export default {
  ...registrationStyles,
  subTitle: {
    fontSize: '24px',
    '@media screen and (max-width: 600px)': {
      fontSize: '18px',
      textAlign: 'left',
    },
  },
  fieldRow: {
    '@media screen and (max-width: 600px)': {
      width: '100% !important',
      margin: '0 !important',
      '& > .MuiGrid-item': {
        padding: '8px 0 !important',
      },
    },
  },
};
